import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

import Text,{H1} from '@dbk/ui-text';
import ScrollableLayout from '../../../../../../src/components/common/scrollable-layout';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import './style.css';
import { downloadPdf } from '../../../../../../src/muster/utils/downloader';
import config from '../../../../../../src/data/settings.json';
import isEnterorSpaceKeyPressed  from '../../../../../../src/utils/isEnterorSpaceKeyPressed';

class TermsCondition extends Component {
  componentWillMount() {
    this.props.loginTerms.onGetPdf();
  }

  onDownload = (item, e) => {
    if(isEnterorSpaceKeyPressed(e)){
      downloadPdf(item.link, item.fileName, 'application/pdf');
    }
  }

  render() {
    const { i18n: { messages }, loginTerms: { pdfLinkData } } = this.props;

    const remoteUrl = window.location.href.split('ebanking')[0] + config.environments.relative.remoteUrl;
    const termsLink = remoteUrl + pdfLinkData.tcPdfLink;
    const privacyLink = remoteUrl + pdfLinkData.paPdfLink;
    
    const items = [{
      "link": termsLink,
      "fileName": pdfLinkData.tcPdfFileName,
      "nameID": 'app.terms.termsPdf'
    },
    {
      "link": privacyLink,
      "fileName": pdfLinkData.paPdfFileName,
      "nameID": 'app.terms.privacyPdf'
    }];


    return (
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="padding-left-20 row consolidation">
            <div className="cloumns small-12 large-12 profile-container">
              {
                (pdfLinkData.tcPdfLink == null || pdfLinkData.paPdfLink == null) ?
                  <div className="columns small-12 small-centered medium-9 medium-centered large-8 large-centered">
                    <div className="text-center" tabIndex={0}>
                      <span className='term-condition'>{messages['app.terms.linkError']}</span>
                    </div>
                  </div>
                  :
                  <div>
                    <div id="title_legalPage_termsCondition_test" className="profile-container__title">
                      <H1 className="margin-top-1" tabIndex={0}>{messages['app.common.legal']}</H1>
                    </div>
                    <div className="settings-list">
                      <div className="term-condition">
                        <NavigationList>
                          {
                            items && items.map((item) => (
                              <NavigationListItem tabIndex={-1}
                                label={messages['app.downloads.download'] + messages[item.nameID]}
                                onKeyDown={(e) => this.onDownload(item, e)}
                                hasArrow key={messages[item.nameID]} onClick={() => this.onDownload(item)}>

                                <Text size="large" tabIndex={0}>{messages[item.nameID]}</Text>

                              </NavigationListItem>
                            ))
                          }
                        </NavigationList>
                      </div>
                    </div>
                  </div>
              }
            </div>
          </div>
        }
      />
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    loginTerms: {
      pdfLinkData: true,
      onGetPdf: { $call: 'getPdfLink' }
    }
  },
})(TermsCondition);
